export default __webpack_public_path__ + "static/media/crachá-vertical.58172ce2.png";